/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { Badge, BadgeType } from '../interface/types';

export const findBadgeById = (badges: BadgeType[], badgeId: Badge) => {
  return badges.find((badge) => badge.badgeId === badgeId);
};
